import { PeriodAthlete } from 'oas';

export const SavingState = {
    none: 'none',
    saving: 'saving',
    saved: 'saved',
} as const;

export type SavingStateEnum = typeof SavingState[keyof typeof SavingState];

export interface AePeriod {
    id: string;
    name: string;
    startDateTime: Date;
    endDateTime: Date;
    duration: number;
    athleteIds: string[];
    activityId: string;
    athleteCount: number;
    periodAthletes: PeriodAthlete[];
}

/** Graph parameter options  */
export const GraphDataType = {
    Velocity: 'v',
    PlayerLoad: 'pli',
    HeartRate: 'hr',
} as const;

export type GraphDataTypeEnum = typeof GraphDataType[keyof typeof GraphDataType];

export const GraphTool = {
    zoom: 'zoom',
    drawPeriod: 'drawPeriod',
    rotation: 'rotation',
} as const;

export type GraphToolEnum = typeof GraphTool[keyof typeof GraphTool];

export const GraphType = {
    overlapped: 'ograph',
    individual: 'igraph',
} as const;

export type GraphTypeEnum = typeof GraphType[keyof typeof GraphType];
